import { useEffect, useRef } from 'react';
export function useAccessibilityWarning(props) {
    const { selected, label } = props;
    const initialSelected = useRef(selected);
    const initialLabel = useRef(label);
    useEffect(() => {
        if (__DEV__) {
            if (initialSelected.current !== selected && initialLabel.current !== label) {
                // eslint-disable-next-line no-console
                console.warn(`CheckButton: To avoid confusion for screen reader users the "label" prop should not change when the "selected" prop changes. 
          Examples of screen reader output depending on the props: 
          
          GOOD: 
            * label="Mute", selected=false => "Mute, toggle button, not pressed".
            * GOOD: label="Mute", selected=true => "Mute, toggle button, pressed".
          
          BAD (both scenarios indicate that it's currently unmuted):  
            * label="Mute", selected=false => "Mute, toggle button, not pressed".
            * label="Unmute", selected=true => "Unmute, toggle button, pressed".
          `);
            }
        }
    }, [label, selected]);
}
